import type { SwipeTranslation } from '@lotta/shared/types-lottery-schemas';
import { useCallback } from 'react';
import type { Row } from 'write-excel-file';
import writeXlsxFile from 'write-excel-file';
import { FileDownloadButton } from '../../components/file-download-button/FileDownloadButton';

export type DownloadSwipeQuestionsProps = {
  questions: SwipeTranslation['questions'];
  label: string;
  fileName: string;
};

export const DownloadSwipeQuestions: React.FC<DownloadSwipeQuestionsProps> = ({
  questions,
  label,
  fileName,
}) => {
  const handleOnClick = useCallback(() => {
    const header: Row = [
      { type: String, value: 'Questions (max 120 characters)', fontWeight: 'bold' },
      { type: String, value: 'Description (max 120 characters)', fontWeight: 'bold' },
      {
        type: String,
        value: 'Answer text if correct answer (max 30 characters)',
        fontWeight: 'bold',
      },
      {
        type: String,
        value: 'Answer text if incorrect answer (max 30 characters)',
        fontWeight: 'bold',
      },
      { type: String, value: 'Answer', fontWeight: 'bold' },
      { type: String, value: 'Image (max 500 characters)', fontWeight: 'bold' },
    ];
    const data = questions.map<Row>(
      ({ question, description, correctAnswerText, wrongAnswerText, answer, image }) => [
        { type: String, value: question },
        { type: String, value: description },
        { type: String, value: correctAnswerText },
        { type: String, value: wrongAnswerText },
        { type: String, value: answer ? 'TRUE' : 'FALSE' },
        { type: String, value: image },
      ]
    );
    writeXlsxFile([header, ...data], { fileName });
  }, [questions, fileName]);

  return <FileDownloadButton label={label} onDownload={handleOnClick} />;
};
